import Question from "../Question/Question";
import VoiceRecorder from "../../VoiceRecorder/VoiceRecorder";
import { Select } from "antd";
import { useState } from "react";
import ImageUploader from "../../ImageUploader/ImageUploader";

const MediaManager = (props) => {
  const { label, onChange, disabled, field_type, media, ...other } = props;
  const [mediaType, setMediaType] = useState(field_type ?? "voice");

  return (
    <Question {...props} type="مدیا" noRequired noDescription noLabel>
      <div
        style={{
          width: "100%",
          height: "100%",
          marginBottom: !disabled && "2rem",
        }}
      >
        {!disabled && (
          <>
            <Select
              style={{ width: "100%", marginBottom: "0.5rem" }}
              placeholder="نوع سوال"
              onChange={(e) => {
                onChange("field_type", e);
                setMediaType(e);
              }}
              value={mediaType}
            >
              <Select.Option value="voice">صوت</Select.Option>
              <Select.Option value="image">تصویر</Select.Option>
            </Select>

            {mediaType === "voice" && (
              <VoiceRecorder onChange={onChange} initialMedia={media} />
            )}
            {mediaType === "image" && (
              <ImageUploader onChange={onChange} initialMedia={media} />
            )}
          </>
        )}
      </div>
    </Question>
  );
};
export default MediaManager;
